import React from 'react';
import styles from './Logo.module.scss';

interface LogoProps {
  className?: string;
  showIcon?: boolean;
  iconText?: string;
}

export const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  showIcon = true, 
  iconText = 'E' 
}) => {
  return (
    <div className={`${styles.logo} ${className}`}>
      <img src="/images/logo/logo.svg" alt="Logo" />
      {showIcon && (
        <div className={styles.logoIcon}>
          {iconText}
        </div>
      )}
    </div>
  );
};

export default Logo;
